import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import catalogImage from 'assets/images/catolog-home.png';
import complaintsImg from 'assets/images/complaints.png';
import diversoImage from 'assets/images/diverso-home.png';
import instructionsImg from 'assets/images/instructions.png';
import p305Image from 'assets/images/p305-home.png';
import priceListImage from 'assets/images/pricing-home.png';
import technicalCutoutsImg from 'assets/images/technical-cutout.png';
import technicalCutoutssImg from 'assets/images/technical-cutouts.png';
import ordersImage from 'assets/images/orders.png';
import Logo from 'components/Logo';
import { SwitchLang } from 'components/SwitchLang';
import { routes } from 'routes';
import { colors } from 'styles/colors';
import { devices } from 'styles/devices';
import MainTemplate from 'templates/MainTemplate/MainTemplate';
import NavBox from './NavBox';
import News from './News';

const getCurrentLang = () => {
   const lang = localStorage.getItem('KNS_INFO_CURRENT_LANG');

   if (lang === 'eng' || lang === 'ukr') {
      return '/en';
   }

   return '';
};

const PRICE_LIST = 'https://pricelist.konsport.com.pl';

const HomeView = () => {
   const intl = useIntl();

   return (
      <MainTemplate>
         <InnerWrapper>
            <Header>
               <Logo />
               <SwitchLang />
            </Header>
            <Main>
               <News />
               <Title>
                  <FormattedMessage id="TechnicalDocumentation.ToolsForDistributors" />
               </Title>
               <Boxes>
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.0.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.0.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.0.Description' })}
                     imageSrc={ordersImage}
                     link="https://zamowienia.konsport.com.pl/"
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.1.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.1.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.1.Description' })}
                     imageSrc={catalogImage}
                     path={routes.catalog}
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.2.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.2.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.2.Description' })}
                     imageSrc={priceListImage}
                     link={`${PRICE_LIST}${getCurrentLang()}`}
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.3.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.3.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.3.Description' })}
                     imageSrc={instructionsImg}
                     path={`/instrukcje/21774`}
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.4.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.4.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.4.Description' })}
                     imageSrc={diversoImage}
                     link="https://www.diverso.konsport.com/"
                     isHref
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.5.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.5.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.5.Description' })}
                     imageSrc={p305Image}
                     link="https://www.xps.konsport.com/"
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.7.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.7.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.7.Description' })}
                     imageSrc={technicalCutoutsImg}
                     link="https://www.kreator.konsport.com"
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.8.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.8.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.8.Description' })}
                     imageSrc={complaintsImg}
                     link="https://reklamacje.konsport.com.pl"
                  />
                  <NavBox
                     alt={intl.formatMessage({ id: 'NavBox.9.Alt' })}
                     headline={intl.formatMessage({ id: 'NavBox.9.Headline' })}
                     description={intl.formatMessage({ id: 'NavBox.9.Description' })}
                     imageSrc={technicalCutoutssImg}
                     link="https://www.wyciecia.konsport.com"
                  />
               </Boxes>
            </Main>
         </InnerWrapper>
      </MainTemplate>
   );
};

const Title = styled.h2`
   color: ${colors.white};
   font-size: 1.6rem;
   font-weight: 700;
   margin-bottom: 0.75rem;

   ${devices.mobileL} {
      margin-bottom: 1.5rem;
   }

   ${devices.tabletL} {
      font-size: 2.8rem;
      margin-bottom: 3rem;
   }
`;

const InnerWrapper = styled.div`
   padding: 20px;
   max-width: 1920px;

   ${devices.tabletL} {
      padding: 0 60px;
   }

   ${devices.tabletXL} {
      padding: 0 100px;
   }
`;

const Boxes = styled.div`
   display: grid;
   grid-template-columns: 1fr;
   column-gap: 20px;
   row-gap: 20px;

   ${devices.tabletL} {
      grid-template-columns: repeat(3, 1fr);
   }
`;

const Header = styled.header`
   min-height: 40px;
   display: flex;
   align-items: center;
   justify-content: space-between;

   ${devices.desktop} {
      padding: 30px 0;
   }

   ${devices.desktopFHD} {
      padding: 50px 0;
   }
`;

const Main = styled.main`
   display: block;
   margin-top: 1rem;

   ${devices.tabletL} {
      margin-top: 2rem;
   }
`;

export default HomeView;
